module.exports = __webpack_public_path__ + "media/images/confirmation-info-background-1cf7aea46e68b8add48c6ebca45a2782.png";